import { createAsyncThunk } from '@reduxjs/toolkit';
import campaignApi from '~/apis/campaign';

import { CREATE_CAMPAIGN, EDIT_CAMPAIGN, GET_CAMPAIGN, GET_CAMPAIGNS } from '~/utils/constants/actionType';
import { ICampaign, IParamsGetCampaign, IResponseGetCampaign } from '~/utils/interface/campaign';

export const handleCreateCampaign = createAsyncThunk<ICampaign, ICampaign>(
  CREATE_CAMPAIGN,
  async (data: ICampaign, { rejectWithValue }) => {
    try {
      const res = await campaignApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetCampaigns = createAsyncThunk<IResponseGetCampaign, IParamsGetCampaign>(
  GET_CAMPAIGNS,
  async (params: IParamsGetCampaign = {}, { rejectWithValue }) => {
    try {
      const res = await campaignApi.getList(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCampaign = createAsyncThunk<ICampaign, string>(
  GET_CAMPAIGN,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await campaignApi.getDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleEditCampaign = createAsyncThunk<ICampaign, { id: string; params: ICampaign }>(
  EDIT_CAMPAIGN,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await campaignApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
